import { html, TemplateResult } from 'lit';

/**
 * Utility functions for creating preview popup UI components.
 * These functions provide a consistent way to display content with preview popups.
 */

/**
 * Creates a preview popup that shows content on hover and focus.
 * Uses the webmodule-preview component with proper keyboard accessibility,
 * focus handling, and Escape-to-dismiss functionality.
 * Content is displayed as plain text with preserved line breaks and vertical scrolling.
 * Default dimensions (400px width, 200px height) are defined in preview.styles.ts.
 *
 * @param triggerElement The element that triggers the preview (typically a button)
 * @param previewTitle The title to display in the preview header
 * @param previewContent The content to display in the preview body
 * @returns A template result with the preview wrapping the trigger element
 */
export function createContentPreview(
  triggerElement: TemplateResult,
  previewTitle: string,
  previewContent: string
): TemplateResult {
  return html`
    <webmodule-preview placement="top" hoist>
      ${triggerElement}
      <span slot="title">${previewTitle}</span>
      <div slot="content">${previewContent}</div>
    </webmodule-preview>
  `;
}
